import type { FunctionComponent } from "react";

import type { StyledProps } from "./styles";
import { Container, Duration, Icon } from "./styles";

type Props = {
  duration: string;
} & PropsFromStyledProps<StyledProps>;

export const DefaultVideoDurationOverlay: FunctionComponent<Props> = ({
  duration,
  responsiveVariants,
}) => (
  <Container $responsiveVariants={responsiveVariants}>
    <Icon /> <Duration>{duration}</Duration>
  </Container>
);
